import React from 'react';
import { Text, IconButton, Flex, Image } from '@chakra-ui/react';
import { AiOutlineDelete } from 'react-icons/ai';
import { useRemoveClient } from 'components/ghostwriter/useRemoveClient';

export const CreatorListItem = ({ creator, index }) => {
  const { onOpen, isLoading, RemovePopup } = useRemoveClient(creator);

  return (
    <Flex justifyContent="space-between" alignItems="center" w="100%">
      <Flex>
        <Image
          src={creator.image ?? '/assets/resources/emptyProfile.png'}
          w="6"
          h="6"
          rounded="full"
        />
        <Text ml={2}>{creator.name}</Text>
      </Flex>
      <IconButton
        aria-label="remove-creator"
        variant="ghost"
        size="xs"
        isLoading={isLoading}
        onClick={async () => {
          onOpen();
        }}
        icon={<AiOutlineDelete />}
      />
      <RemovePopup />
    </Flex>
  );
};
